module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="cityPreview js-city-preview">\r\n	<span class="h3">'+
((__t=( directionTitle ))==null?'':__t)+
'</span>\r\n	<span class="cityPreview_img" style="background-image:url(\''+
((__t=( imageProxy(cover, {width:426,height:320}) ))==null?'':__t)+
'\')"></span>\r\n	<span class="cityPreview_label">\r\n		';
 if(!_.isEmpty(restTypes)) {
			var groupCounter = 0,
				iconsPerGroup = 5;

			restTypes.each(function(restType) {
				if (groupCounter % iconsPerGroup === 0) {
					
__p+='<span class="iconGroup">';

				}
				
__p+='<i class="icon icon-rtype_i16_'+
((__t=( restType.get('id') ))==null?'':__t)+
'" title="'+
((__t=( restType.get('name') ))==null?'':__t)+
' - '+
((__t=( restType.get('description') ))==null?'':__t)+
'"></i>';

				if ((groupCounter + 1) % iconsPerGroup === 0 && groupCounter) {
					
__p+='</span>';

				}
				groupCounter++;
			});
			if ((groupCounter + 1) % iconsPerGroup !== 0 || groupCounter) {
				
__p+='</span>';

			}
		} 
__p+='\r\n	</span>\r\n	<span class="cityPreview_price js-city-preview-price" style="display:none;">\r\n		<span>от</span>\r\n		<span class="cityPreview_price_value js-city-preview-price-value"></span>\r\n		<span class="rubl">руб.</span>\r\n	</span>\r\n</a>';
}
return __p;
};
